import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Button, Card, Typography } from '@altermaind/web/ui';
import { VerticalStepper } from '@/_shared/components/VerticalStepper';
import { Step } from '@/_shared/components/VerticalStepper/types';
import { Routes } from '@/_shared/constants/routes';
import { getEmployerNotCompletedSurveysCall } from '@/surveys/state/api';

type Props = {
  templateId?: string;
};

export const SurveyNotCompleted: FC<Props> = ({ templateId }) => {
  const t = useTranslations('assessments.surveyNotCompleted');
  const navigate = useNavigate();
  const { response: responseGetEmployerNotCompletedSurveys } =
    getEmployerNotCompletedSurveysCall.hook();

  const steps: Step[] = [
    responseGetEmployerNotCompletedSurveys
      ?.filter(survey => survey.templateId === templateId)
      .map(survey => ({
        title: survey.templateName || t('steps.title'),
        description: (
          <Box>
            <Typography variant='p3/light'>
              {t(`steps.description.${survey.templateName}`)}
            </Typography>
            <Button
              onClick={() =>
                survey.campaignId
                  ? navigate(Routes.SurveyToComplete.replace(':campaignId', survey.campaignId))
                  : null
              }
              mt='s'
              variant='positive'
            >
              {t('steps.ctaLabel')}
            </Button>
          </Box>
        ),
        isCompleted: false,
        iconName: 'survey',
      })) || [],
  ].flat();

  if (steps.length === 0) {
    return (
      <Box mb='s'>
        <Typography variant='p3/light'>{t('noSurvey')}</Typography>
      </Box>
    );
  }

  return (
    <Box mb='s'>
      <Typography variant='h2' mb='xs'>
        {t('title')}
      </Typography>
      <Card>
        <VerticalStepper primaryStyle noBorder steps={steps} />
      </Card>
    </Box>
  );
};
